/**
 * 공용 레이어 스택 매니저 — 오버레이(Modal/BS/기타)가 같은 스택을 공유해
 * z-index 를 레벨별로 증분 부여한다. 여러 모달이 겹쳐 떠도 항상 최신이 위로.
 *
 * z-index 기준 슬롯은 CSS 변수(:root 의 --z-index-modal-backdrop / --z-index-modal)를 읽는다.
 * (shared/abstracts/_z-index.scss). BS(1035)보다 modal(1055)이 위라, Modal 은 기본적으로
 * BS 위에 뜬다 — BS 안에서 연 모달도 자연히 위로 스택된다.
 *
 *   const level = $j.Ui.Layer.push('modal:abc');   // 스택에 올리고 레벨 반환
 *   const { backdrop, panel } = $j.Ui.Layer.z('modal:abc');
 *   $j.Ui.Layer.remove('modal:abc');
 */
export default class Layer {
    constructor() {
        this._stack = [];  // 열린 순서(맨 뒤가 최상단)
        this.STEP = 20;    // 레벨당 z-index 증가폭 (STEP > modal-backdrop 간격이어야 위 backdrop 이 아래 panel 을 덮음)
    }

    _baseZ(varName, fallback) {
        if (typeof document === 'undefined') return fallback;
        const v = getComputedStyle(document.documentElement).getPropertyValue(varName);
        return parseInt(v, 10) || fallback;
    }

    /** 스택에 올린다(이미 있으면 최상단으로 재배치). @return {number} 레벨(0-base) */
    push(key) {
        const i = this._stack.indexOf(key);
        if (i !== -1) this._stack.splice(i, 1);
        this._stack.push(key);
        return this.level(key);
    }

    /** 스택에서 제거 */
    remove(key) {
        const i = this._stack.indexOf(key);
        if (i !== -1) this._stack.splice(i, 1);
    }

    /** 현재 레벨(0-base). 없으면 0 */
    level(key) {
        const i = this._stack.indexOf(key);
        return i < 0 ? 0 : i;
    }

    /** key 의 backdrop/panel z-index */
    z(key) {
        const level = this.level(key);
        const backdrop = this._baseZ('--z-index-modal-backdrop', 1050);
        const panel = this._baseZ('--z-index-modal', 1055);
        return { backdrop: backdrop + level * this.STEP, panel: panel + level * this.STEP };
    }

    /** 최상단 key */
    top() { return this._stack.length ? this._stack[this._stack.length - 1] : null; }

    /** 열려 있는 레이어 수 */
    count() { return this._stack.length; }
}
